import { H5, styled, View } from "dripsy";

const Section = styled(View)({ mb: "$6" });
const SectionHeader = styled(H5)({ fontSize: 16, lineHeight: 24, mb: "$4" });

export { Section, SectionHeader };
